export async function loadFonts () {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */'webfontloader')
  webFontLoader.default.load({
    google: {
      families: [
        'Archivo:wght@500;600;700;800;900',
        'Source+Sans+3:wght@400;600;700',
        'IBM+Plex+Mono:wght@400;500;600',
      ],
    },
  })
}
